module.exports = __webpack_public_path__ + "static/img/415.4e64eed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/191007/415.jpg
// module id = ntW0
// module chunks = 0